import React, { useCallback } from 'react';
import { useTranslations } from '@components/context';
import Button from '@components/legacy/core/Button';
import { AutomationSummaryChip } from '@components/Automations';
import classNames from 'classnames';

const getShowConfirmationOverlay = () =>
    window.show_confirmation_overlay ||
    ((id, title, msg, cancel, confirm) => {
        if (window.confirm(`${title}\n${msg}`)) {
            confirm.action?.();
        }
    });

export function AutomationRulesList({
    rules = [],
    onDeleteRule,
    onOpenRule,
    category,
    contextId,
}) {
    const { t } = useTranslations();

    const handleRemoveClick = useCallback(
        (rule) => {
            if (!onDeleteRule || !rule._links?.delete) {
                return;
            }
            const show_confirmation_overlay = getShowConfirmationOverlay();
            show_confirmation_overlay(
                'confirm_automation_removal',
                t('confirm_automation_removal'),
                t('Are you sure you want to delete this automation?'),
                { label: t('cancel') },
                {
                    label: t('delete'),
                    action: () => {
                        void onDeleteRule(rule);
                    },
                },
            );
        },
        [onDeleteRule, t],
    );

    const handleOpenRuleClick = useCallback(
        (rule) => {
            if (!onOpenRule || !rule._links?.get_rule) {
                return;
            }
            onOpenRule(rule, { category, contextId });
        },
        [onOpenRule, category, contextId],
    );

    return (
        <>
            {rules.map((rule) => (
                <AutomationSummaryChip
                    key={rule.id}
                    className={classNames({
                        'automation-summary-chip--message': true,
                    })}
                    tooltipText={null} // TODO: add tooltip text
                    icon={rule.icon}
                    label={rule.label || rule.name}
                    content={rule.short_description}
                    onRemove={() => (onDeleteRule && rule._links?.delete) ? handleRemoveClick(rule) : undefined}
                    onClick={() => handleOpenRuleClick(rule)}
                />
            ))}
        </>
    );
}
